import { useTranslation } from 'react-i18next'
import { ValidateAddress } from './validate_address'
import Header from './components/header'
import {
    HomepageWrapper,
    HomepageInner,
    HeroSection,
    HeroCard,
    HeroContent,
    HeroHighlight,
    HeroFeatures,
    IntroSection,
    IntroInner,
} from './components/styles/Homepage.styled'

export const Homepage = () => {
    const { t } = useTranslation('homepage')

    return (
        <HomepageWrapper>
            <HomepageInner id="main-content">
                <Header />
                <HeroSection>
                    <HeroCard>
                        <HeroContent>
                            <h1>
                                {t('Proudly Serving thousands of')}
                                <br />
                                <HeroHighlight>
                                    {t('Texas residential customers')}
                                </HeroHighlight>{' '}
                                {t('with the power to choose')}
                            </h1>
                            <HeroFeatures>
                                <li>
                                    <span className="feature-step" aria-hidden="true">
                                        1.
                                    </span>
                                    {t('Start with your address')}
                                </li>
                                <li>
                                    <span className="feature-step" aria-hidden="true">
                                        2.
                                    </span>
                                    {t('See personalized options')}
                                </li>
                                <li>
                                    <span className="feature-step" aria-hidden="true">
                                        3.
                                    </span>
                                    {t('Choose with clarity')}
                                </li>
                            </HeroFeatures>
                            <ValidateAddress />
                        </HeroContent>
                    </HeroCard>
                </HeroSection>
                <IntroSection>
                    <IntroInner>
                        <h2>
                            {t('True cost,')}
                            <br />
                            {t('clear choice')}
                        </h2>
                        <p>
                            {t(
                                'Texas Energy Group makes it easier to compare electricity rates, understand the true cost of service, and enroll in a plan that fits your home size and budget. Our residential shopping experience uses AI data-driven plan comparison tools to help cut through confusing rates, misleading plan structures, and time-consuming research'
                            )}
                        </p>
                    </IntroInner>
                </IntroSection>
            </HomepageInner>
        </HomepageWrapper>
    )
}
